import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/attendance-management-system/attendance-dashboard/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "attendance-dashboard" entry is kept); the seo block below is a fallback.

export const attendanceDashboard: ContentPage = {
  slug: "attendance-management-system/attendance-dashboard",
  template: "hrmsFeature",
  seo: {
    title: "Intuitive Attendance Dashboard for Real-Time Monitoring",
    description: "Manage and analyze employee attendance effectively with our customizable, real-time dashboard, equipped with alerts and comprehensive data visualization.",
    keywords: [
      "attendance dashboard",
      "real-time attendance tracking",
      "employee attendance monitor",
      "interactive attendance management",
      "attendance visualization.",
    ],
    ogImage: "/assets/data/seoimages/attendance-dashboard.webp",
  },
  leaf: {
    hero: {
      caption: "Attendance Dashboard",
      title: "Centralize Attendance Management with Our Dashboard",
      description: "Visualize and manage all attendance data through a single intuitive dashboard, enhancing your ability to monitor and adjust in real-time.",
      h1: "caption",
    },
    split: {
      title: "All-in-One Attendance Monitoring Interface",
      bullets: [
        { title: "Real-Time Data Visualization", description: "See up-to-date attendance information with interactive charts." },
        { title: "Customizable Views", description: "Adjust the dashboard to show relevant data by department or shift." },
        { title: "Alerts and Reminders", description: "Get notified immediately about attendance discrepancies." },
        { title: "Interactive Tools", description: "Use built-in tools for detailed analysis and management." },
      ],
      image: "/assets/images/img/product/hrms/attendancems/attendance-dashboard.webp",
      imageAlt: "attendance-dashboard",
    },
    cardsHeading: {
      title: "Key Features of Attendance Management System",
      description: "Optimize Attendance management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Shift Management",
        href: "/hrms-software/attendance-management-system/shift-management",
        description: "Manage and automate employee shifts efficiently to ensure coverage and reduce scheduling conflicts with our advanced shift management tools.",
        image: "/assets/images/img/product/hrms/attendancems/shift_management_key_features.webp",
        imageAlt: "shift_management_key_features",
      },
      {
        title: "Comprehensive Reporting",
        href: "/hrms-software/attendance-management-system/comprehensive-reporting",
        description: "Access detailed attendance reports to make informed decisions about labor costs, employee productivity, and shift planning.",
        image: "/assets/images/img/product/hrms/attendancems/comprehensive_reporting_key_features.webp",
        imageAlt: "comprehensive_reporting_key_features",
      },
      {
        title: "Overtime Monitoring",
        href: "/hrms-software/attendance-management-system/overtime-monitoring",
        description: "Ensure fair compensation and compliance with our sophisticated overtime monitoring system, reducing discrepancies and boosting morale.",
        image: "/assets/images/img/product/hrms/attendancems/overtime-monitoring_key_features.webp",
        imageAlt: "overtime-monitoring_key_features",
      },
      {
        title: "Geofencing Attendance",
        href: "/hrms-software/attendance-management-system/geofencing-attendance",
        description: "Utilize geofencing technology to manage employee attendance more securely and accurately, ideal for remote or on-site tracking.",
        image: "/assets/images/img/product/hrms/attendancems/geofencing_attendance_key_features.webp",
        imageAlt: "geofencing_attendance_key_features",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Enhance Monitoring with Our Interactive Dashboard!",
    relatedBlogsKeyword: "hrms-attendance-management-dashboard,hrms-leave-and-absence-management,hrms-leave-and-absence-management",
    metaKey: "attendance-dashboard",
  },
  sections: [],
};
